function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M21,7.2H1.7c-0.2,0-0.3,0.2-0.3,0.4V9c0,0.2,0.2,0.4,0.3,0.4h3.4v6.5l6.2-2l6.2,2V9.4h1.7v3.5h0.1c0,0,0,0,0,0 v0.3h0c-0.2,0-0.4,0.3-0.4,0.5h-0.1c-0.1,0-0.1,0.1-0.1,0.2v1c0,0.1,0.1,0.2,0.1,0.2H19v0.6c0,0.1,0.1,0.2,0.2,0.2h0.8 c0.1,0,0.2-0.1,0.2-0.2v-1.4c0-0.6-0.2-1-0.5-1v-0.3c0,0,0,0,0,0h0.1V9.4H21c0.2,0,0.3-0.2,0.3-0.4V7.6C21.3,7.4,21.2,7.2,21,7.2z"
});

var SvgSb4 = function SvgSb4(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_4",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22.7 22.7",
    style: {
      enableBackground: "new 0 0 22.7 22.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 0,
    y1: 0,
    x2: 6.123234e-17,
    y2: -1
  }, React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#656666"
    }
  }), React.createElement("stop", {
    offset: 0.618,
    style: {
      stopColor: "#1A1A1A"
    }
  }), React.createElement("stop", {
    offset: 0.6292,
    style: {
      stopColor: "#545554"
    }
  }), React.createElement("stop", {
    offset: 0.9831,
    style: {
      stopColor: "#3E3E3E"
    }
  })), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSb4, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sb-4.1251cffc.svg";
export { ForwardRef as ReactComponent };